import { enConfig } from './en';
import { esConfig } from './es';

export const localeConfigs: Record<string, Partial<InitOptions>> = {
  es: esConfig,
  en: enConfig,
};
